import { useOutlet } from "react-router-dom";
import { useEffect } from "react";
import { observer } from "mobx-react";
import { useStores } from "../../stores";
import { HEADER_TYPE } from "../../constants";

interface OrderPagesProps {}

export const OrderPages = observer(({}: OrderPagesProps) => {
	const { settingsStore } = useStores();

	const outlet = useOutlet();

	useEffect(() => {
		settingsStore.setTypeHeader(HEADER_TYPE.RELATIVE);
	}, []);

	return <>{outlet}</>;
});
